<section class="plans-page">
  <header>
    <div>
      <p>Platform control</p>
      <h2>Business subscription plans</h2>
      <small>Control modules and usage limits before approving businesses.</small>
    </div>
  </header>
  @if (error()) {
    <p class="state error">{{ error() }}</p>
  }
  @if (success()) {
    <p class="state success">{{ success() }}</p>
  }
  <div class="layout">
    <form (ngSubmit)="save()" [class.readonly]="!(editingId ? can('SUBSCRIPTION_PLAN_UPDATE') : can('SUBSCRIPTION_PLAN_CREATE'))">
      <h3>{{ editingId ? 'Edit plan' : 'Create plan' }}</h3>
      <div class="fields">
        <label
          >Plan name<input
            name="name"
            [(ngModel)]="form.name"
            required
            placeholder="Starter" /></label
        ><label
          >Price (₹)<input name="price" type="number" min="0" [(ngModel)]="form.price" /></label
        ><label
          >Billing period<select name="period" [(ngModel)]="form.billingPeriod">
            <option>Monthly</option>
            <option>Quarterly</option>
            <option>Yearly</option>
            <option>OneTime</option>
          </select></label
        ><label
          >Trial days<input name="trial" type="number" min="0" [(ngModel)]="form.trialDays"
        /></label>
      </div>
      <label
        >Description<textarea
          name="description"
          rows="3"
          [(ngModel)]="form.description"
          placeholder="Who this plan is for"
        ></textarea>
      </label>
      <h4>Usage limits</h4>
      <div class="fields limits">
        <label>Users<input name="users" type="number" min="1" [(ngModel)]="form.maxUsers" /></label
        ><label>Roles<input name="roles" type="number" min="0" [(ngModel)]="form.maxRoles" /></label
        ><label
          >Locations<input
            name="locations"
            type="number"
            min="1"
            [(ngModel)]="form.maxLocations" /></label
        ><label
          >All listings<input
            name="allListings"
            type="number"
            min="0"
            [(ngModel)]="form.maxProductListings" /></label
        ><label
          >New listings<input
            name="newListings"
            type="number"
            min="0"
            [(ngModel)]="form.maxNewProductListings" /></label
        ><label
          >Used listings<input
            name="usedListings"
            type="number"
            min="0"
            [(ngModel)]="form.maxUsedProductListings"
        /></label>
      </div>
      <h4>Included modules</h4>
      <div class="permissions">
        @for (permission of permissions(); track permission.id) {
          <label
            ><input
              type="checkbox"
              [checked]="form.permissionIds.includes(permission.id)"
              (change)="togglePermission(permission.id, $any($event.target).checked)"
            /><span
              ><strong>{{ permission.name }}</strong
              ><small>{{ permission.module }}</small></span
            ></label
          >
        }
      </div>
      <div class="checks">
        <label><input type="checkbox" name="customRoles" [(ngModel)]="form.allowCustomRoles" /> Custom roles</label
        >
        <label><input type="checkbox" name="free" [(ngModel)]="form.isFree" /> Free plan</label
        ><label
          ><input type="checkbox" name="default" [(ngModel)]="form.isDefault" /> Default for new
          businesses</label
        ><label><input type="checkbox" name="active" [(ngModel)]="form.isActive" /> Active</label>
      </div>
      <footer>
        <button type="button" class="secondary" (click)="cancel()">Clear</button
        ><button type="submit" [disabled]="saving() || !(editingId ? can('SUBSCRIPTION_PLAN_UPDATE') : can('SUBSCRIPTION_PLAN_CREATE'))">
          {{ saving() ? 'Saving…' : 'Save plan' }}
        </button>
      </footer>
    </form>
    <div class="plan-list">
      @if (loading()) {
        <p class="state">Loading plans…</p>
      }
      @for (plan of plans(); track plan.id) {
        <article>
          <div>
            <span class="badge" [class.default]="plan.isDefault">{{
              plan.isDefault ? 'DEFAULT' : plan.isActive ? 'ACTIVE' : 'INACTIVE'
            }}</span>
            <h3>{{ plan.name }}</h3>
            <strong>{{
              plan.isFree ? 'Free' : '₹' + plan.price + ' / ' + plan.billingPeriod
            }}</strong>
            <p>{{ plan.description }}</p>
          </div>
          <div class="metrics">
            <span>{{ plan.maxUsers }} users</span><span>{{ plan.maxLocations }} locations</span
            ><span>{{ plan.maxRoles }} roles</span
            ><span>{{ plan.maxProductListings }} listings</span
            ><span>{{ plan.maxNewProductListings }} new</span
            ><span>{{ plan.maxUsedProductListings }} used</span>
            <span>{{ plan.allowCustomRoles ? 'Business-managed roles' : 'Role creation disabled' }}</span>
          </div>
          @if (can('SUBSCRIPTION_PLAN_UPDATE')) { <button type="button" (click)="edit(plan)">Edit plan</button> }
        </article>
      } @empty {
        @if (!loading()) {
          <p class="state">No plans created.</p>
        }
      }
    </div>
  </div>
</section>
